<template>
  <div>
    <a-descriptions title="Details" :column="1" bordered>
      <a-descriptions-item label="Value">
        {{ indexValueDetails.value }}
      </a-descriptions-item>
      <a-descriptions-item label="Period Variation (%)">
        {{ indexValueDetails.periodVariation * 100 }}
      </a-descriptions-item>
      <a-descriptions-item label="Standard deviation">
        {{ indexValueDetails.standardDeviation }}
      </a-descriptions-item>
      <a-descriptions-item label="YTD Standard deviation">
        {{ indexValueDetails.ytdStandardDeviation }}
      </a-descriptions-item>
      <a-descriptions-item label="Volatility (%)">
        {{ indexValueDetails.ytdVolatility * 100 }}
      </a-descriptions-item>
      <a-descriptions-item label="Cumulated volatility (%)">
        {{ indexValueDetails.cumulatedVolatility * 100 }}
      </a-descriptions-item>
      <a-descriptions-item label="Return (%)">
        {{ indexValueDetails.return * 100 }}
      </a-descriptions-item>
      <a-descriptions-item label="Cumulated Return (%)">
        {{ indexValueDetails.cumulatedReturn * 100 }}
      </a-descriptions-item>
    </a-descriptions>
    <h3 class="font-bold text-lg mt-8 mb-2">Constituents</h3>
    <table class="text-xs">
      <thead>
        <tr class="border-b border-terracotta">
          <th>Class</th>
          <th class="text-right">Weight</th>
          <th class="text-right">Share value</th>
          <th class="text-right">Dividend</th>
          <th class="text-right">Variation (%)</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="constituentValue in indexValueDetails.constituents"
          :key="constituentValue.constituent"
        >
          <td>
            {{ constituentValue.constituent }}
          </td>
          <td class="text-right">{{ constituentValue.weight }}</td>
          <td class="text-right">{{ constituentValue.shareValue }}</td>
          <td class="text-right">{{ constituentValue.dividend }}</td>
          <td class="text-right">
            {{
              (constituentValue.periodVariation * 100).toLocaleString('en-us', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 5,
              })
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    indexValueDetails: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style scoped>
td,
th {
  @apply px-4 py-2;
}
</style>
